import { TTopFAQ } from '@/entities/support'

import * as Accordion from './accordion'
import { FAQAnswer } from '../faq-answer'

type TopFAQListProps = {
  faqs: TTopFAQ[]
}

export const TopFAQList = ({ faqs }: TopFAQListProps) => {
  return (
    <Accordion.Root type="multiple" className="space-y-4">
      {faqs.map((faq, index) => (
        <Accordion.Item key={faq.id} value={faq.id.toString()}>
          <Accordion.Trigger>
            <span className="w-3 text-purple-500">{index + 1}</span>
            <span className="flex-1 text-left text-gray-900">
              {faq.question}
            </span>
          </Accordion.Trigger>
          <Accordion.Content>
            <FAQAnswer html={faq.answer} />
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  )
}
